// @flow
import React, { Component } from "react"

import * as authApi from "../../tools/authApi"
import cuckoo from "common/services/cuckoo/cuckoo"
import Translate from "../../components/Translate"
import Alert from "common/components/Alert/Alert"
import translate from "../../tools/translate"
import Button from "common/components/Button/Button"
/* eslint-disable jsx-a11y/aria-role */
import { cuckooEvents } from "common/consts/enums"
import NewTextField from "common/components/NewTextField/NewTextField"

type State = {
  value: string,
  error: ?string,
  formError: string,
  loading: boolean,
  touched: boolean,
}

type Props = {
  token: string,
  onClose: () => void,
}

export default class CreatingPasswordModal extends Component<Props, State> {
  state = {
    value: "",
    error: "",
    formError: "",
    loading: false,
    touched: false,
  }

  handleChange = (value: string) => {
    const error = this.getPasswordErrors(value)
    this.setState({
      touched: true,
      value,
      error,
    })
  }

  getPasswordErrors = (password: string) => {
    const userInput = ["skypicker", "kiwi"]

    if (password.length < 8) {
      return __("account.password_too_short")
    }

    // $FlowFixMe
    if (typeof zxcvbn === "function") {
      const strength = zxcvbn(password, userInput) // eslint-disable-line no-undef
      if (strength.score < 2) return __("account.password_too_simple")
    } else {
      console.log("password validation througth zxcvbn is not available")
    }
    return null
  }

  submitHandler = (ev: SyntheticEvent<>) => {
    ev.preventDefault()

    this.setState({
      loading: true,
    })

    authApi.changePasswordWithToken(this.props.token, this.state.value).then(
      () => {
        cuckoo.track(cuckooEvents.AUTH_PASSWORD_RESET_SUCCESS)
        this.props.onClose()
        vex.closeAll()
        vex.dialog.alert(translate("account.password_changed"))
      },
      err => {
        cuckoo.track(cuckooEvents.AUTH_PASSWORD_RESET_ERROR_UNKNOWN, { msg: err })

        this.setState({
          loading: false,
          formError: err,
        })
      },
    )
  }

  render() {
    const { error, touched, value, loading, formError } = this.state

    return (
      <div className="CreatingPasswordModal">
        <div className="content">
          <p>
            <Translate tKey="account.reset_password" />
          </p>
          {formError && (
            <Alert type="error" closable={false}>
              <span>{formError}</span>
            </Alert>
          )}
          <form className="form form__vertical" onSubmit={this.submitHandler}>
            <NewTextField
              icon={<i className="menu-icon icon-zmdi-lock" />}
              type="password"
              name="password"
              inputStyle="twoLine"
              label={translate("account.password.colon")}
              onChange={this.handleChange}
              value={value}
              touched={touched}
              // $FlowExpected: broken types
              error={error}
              withoutColon
              required
            />

            <Button
              type="submit"
              fullwidth
              size="large"
              loading={loading}
              loadingText={loading}
              disabled={!value || loading || Boolean(error)}
            >
              <Translate tKey="account.reset_password" />
            </Button>
          </form>
        </div>
      </div>
    )
  }
}
